/* global System */
// register component(s) with react habitat

export default {
  PartnerMap: () =>
    System.import(
      /* webpackChunkName: "PartnerMap" */
      './Component'
    ),
}
